import React, { useState, useEffect, useRef } from "react";
import {
  Avatar,
  Box,
  Badge,
  Button,
  Checkbox,
  Grid,
  TextField,
  FormControlLabel,
  Switch,
  FormControl,
  MenuItem,
  InputAdornment,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Modal,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Stack,
  InputLabel,
  Select,
} from "@mui/material";

import {
  CustomChip,
  customHealthPaper,
} from "../../MyProfileDetails/PersonalProfile";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import EventIcon from "@mui/icons-material/Event";
import axios from "axios";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { useCreateCardDetailContext } from "../../../CreatecardDetailContext";
import { useUserDetailContext } from "../../../UserDetailContext";
import FileDragUpload from "../../../Utilities/FileDragUpload";
import Autocomplete from "@mui/material/Autocomplete";
import { FaPlusCircle } from "react-icons/fa";
// import { hobbiesSections } from '../../../Utilities/HobbiesContext';
// import { styled } from '@mui/material/styles';
// import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
// import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
// import ControlPointIcon from '@mui/icons-material/ControlPoint';
import { ReactComponent as AiLogo } from "../../../../Assets/img/icons/ai-rewrite-logo.svg";
// Assets/img/icons/ai-rewrite-logo.svg";
import useNavigationGuard from "./useNavigationGuard";
import { useQuantityContext } from "../../../QuantityContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ReactComponent as TickIcon } from "../../../../Assets/img/icons/tick-shape.svg";
import DeleteIcon from "@mui/icons-material/Delete";
import useApi from "../../../Utilities/useAPI";
import CloseIcon from "@mui/icons-material/Close";
import {
  getAllCardDetailsReducer,
  getAllCardInfoReducer,
  getCardGetCardForExistingEducationReducer,
  getCardsForExistingExperiencesReducer,
  getVisitingCardReducer,
  postCardProfileLogoReducer,
  postCreateCardFromExistingEducationReducer,
  postCreateCardFromOldExperienceReducer,
  postCreateCardWithNewEducationReducer,
  postCreateCardWithNewExperienceReducer,
} from "../../../../Redux/Reducers/CardReducer";
import { useDispatch } from "react-redux";
import CryptoJS from "crypto-js";
import { postCardProfileLogoApi } from "../../../../Redux/helpers/CardHelperApis";
import {
  getEducationLogoReducer,
  getEducationReducer,
  getExperienceReducer,
  getLogoReducer,
  postGenerateDescriptionReducer,
} from "../../../../Redux/Reducers/ProfileReducer";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { values } from "lodash";
import API from "../../../../utils/APIUtils";

const ProfileDetails = ({ handleSuccess, handleFailure }) => {
  const {
    setIsPersonalDetailsSaved,
    isPersonalDetailsSaved,
    cardDetails,
    updateCardDetails,
    updateCardStyles,
    updateCardQrStyles,
    updateContactStyles,
    updateSocialLinks2,
    CardStyles,
    setCardDetails,
    updateAttachDocsVal,
  } = useCreateCardDetailContext();

  const { cards, userDetails, setUserDetails, setOtherCards, AllCards } =
    useUserDetailContext();

  const { setisNavigationBlocked, handleInfo } = useQuantityContext();
  const { callApiFunction } = useApi();
  const [responsibilityInput, setResponsibilityInput] = useState("");
  const currentYear = new Date().getFullYear();

  const kpiOptions = [
    "API Response Time",
    "Average Order Fulfillment Time",
    "Average Resolution Time",
    "A/B Test Results",
    "Annual Revenue Growth",
    "Audience Retention Rate",
    "Bounce Rate",
    "Brand Awareness Metrics",
    "Budget Variance",
    "Bug Fix Rate",
    "Candidate Satisfaction Score",
    "Click-Through Rate (CTR)",
    "Close Rate (Sales Conversion Rate)",
    "Code Quality",
    "Code Review Efficiency",
    "Code Velocity",
    "Conversion Rate from Content",
    "Conversion Rate from Design Changes",
    "Cost per Acquisition (CPA)",
    "Cost Reduction Ratio",
    "Customer Acquisition Cost (CAC)",
    "Customer Feedback Volume",
    "Customer Lifetime Value (CLV)",
    "Customer Retention Rate",
    "Customer Satisfaction Score (CSAT)",
    "Database Optimization",
    "Deliverable Timeliness",
    "Employee Satisfaction Rate",
    "Employee Turnover Rate",
    "Error Rate",
    "First Call Resolution Rate",
    "Feature Adoption Rate",
    "Financial Forecast Accuracy",
    "Gross Profit Margin",
    "Hiring Time (Time to Hire)",
    "Incident Response Time",
    "Inventory Turnover Ratio",
    "Lead Conversion Rate",
    "Leads Generated from Content",
    "Mean Time Between Failures (MTBF)",
    "Monthly Sales Quota Achievement",
    "Net Promoter Score (NPS)",
    "On-Time Delivery Rate",
    "Operating Cash Flow",
    "Page Load Speed",
    "Profitability Ratio",
    "Return on Assets (ROA)",
    "Return on Equity (ROE)",
    "Sales Revenue per Rep",
    "Server Uptime",
    "Sprint Completion Rate",
    "Time to Market",
    "Unit Test Coverage",
    "User Feedback Rating",
  ];
  const years = Array.from(
    { length: currentYear - 1970 + 1 },
    (_, index) => currentYear - index
  );
  const encryptedId = encodeURIComponent(
    CryptoJS.AES.encrypt(
      userDetails.reference_id.toString(),
      "UserDetailsSecretKey"
    ).toString()
  );

  const fullName = userDetails.name;
  const [firstName, lastName] = fullName.split(" ");
  const [SaveEnable, setSaveEnable] = useState(false);
  const message = "You have some UnSaved Changes. Do u want to leave ?";
  useNavigationGuard(SaveEnable, setSaveEnable, message);
  const [open, setOpen] = useState(false);
  const [openExperience, setOpenExperience] = useState(false);

  const location = useLocation();
  const { category } = location.state || {};
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleOpenExperience = () => setOpenExperience(true);
  const handleCloseExperience = () => setOpenExperience(false);
  const ProfessionalEducation =
    useSelector((state) => state?.ProfileArray?.educationData?.data) || [];
  const ProfessionalExperience =
    useSelector((state) => state?.ProfileArray?.experienceData?.data) || [];

  const [EducationCard, setEducationCard] = useState([]);
  const [ExperienceCard, setExperienceCard] = useState([]);

  const [searchText1, setSearchText1] = useState(cardDetails?.institute || "");
  const [selectedUniversity1, setSelectedUniversity1] = useState(null);
  const [searchText2, setSearchText2] = useState(cardDetails?.board || "");
  const [selectedUniversity2, setSelectedUniversity2] = useState(null);
  // console.log("ProfessionalExperienceProfessionalExperience", ProfessionalExperience);
  // console.log("ProfessionalEducation", ProfessionalEducation);

  const isOnlyNumbers = /^\d+$/;
  const sortedEducation = ProfessionalEducation.filter(
    (education, index) => education?.is_pursuing === true
  );
  const sortedExperience = ProfessionalExperience.filter(
    (experience, index) => experience?.is_currently_working === true
  );
  // console.log("sortedEducationsortedEducation", sortedExperience);

  const [directEducationCardCreate, setDirectEducationCardCreate] =
    useState(false);
  const [directExperienceCardCreate, setDirectExperienceCardCreate] =
    useState(false);

  const handleAddChip = (event, input, field) => {
    const keyPressed = event.key;
    const inputValue = input.trim();

    // Only handle 'Enter' or ',' keys when there's input to add
    if ((keyPressed === "Enter" || keyPressed === ",") && inputValue) {
      event.preventDefault(); // Prevent default before updating state
      updateCardDetails((prevState) => {
        const fieldValue = prevState[field];
        if (Array.isArray(fieldValue)) {
          return {
            ...prevState,
            [field]: [...fieldValue, inputValue],
          };
        } else {
          console.error(`${field} is not an array.`);
          return prevState;
        }
      });
      setResponsibilityInput("");
    }
  };

  const handleDeleteChip = (field, chipToDelete) => {
    updateCardDetails((prevState) => ({
      ...prevState,
      [field]: prevState[field].filter((chip) => chip !== chipToDelete),
    }));
  };

  // useEffect(() => {

  //   const handleEducationGetApi = async () => {

  //     for (const education of sortedEducation) {
  //       try {
  //         const response = await dispatch(getCardGetCardForExistingEducationReducer(education?.id));
  //         // console.log("Education Responseeeeeeeee", response);

  //         if (response?.payload?.data?.length === 0) {
  //           setEducationCard((prevState) => {
  //             const exists = prevState.some((item) => item.id === education.id);
  //             if (!exists) {
  //               return [...prevState, education];
  //             }
  //             return prevState;
  //           });

  //         }

  //       } catch (error) {
  //         console.error("Error fetching education card", error);
  //       }
  //     }
  //   };
  //   handleEducationGetApi();
  // }, [])

  // useEffect(() => {

  //   const handleExperienceGetApi = async () => {

  //     for (const experience of sortedExperience) {
  //       try {
  //         const response = await dispatch(getCardsForExistingExperiencesReducer(experience?.id));
  //         // console.log("Experience Responseeeeeeeee", response);

  //         if (response?.payload?.data?.length === 0) {

  //           // setEducationCard((prevState) => [...prevState, education]);

  //           setExperienceCard((prevState) => {
  //             const exists = prevState.some((item) => item.id === experience?.id);
  //             if (!exists) {
  //               return [...prevState, experience];
  //             }
  //             return prevState;
  //           });

  //         }

  //       } catch (error) {
  //         console.error("Error fetching education card", error);
  //       }
  //     }
  //   };
  //   handleExperienceGetApi();
  // }, []);

  // useEffect(() => {
  //   const isValidArray = Array.isArray(ExperienceCard) && ExperienceCard?.length > 0;
  //   const isValidCategory = category === "Customize_Professional" || category === "Professional";

  //   if (isValidArray && isValidCategory) {
  //     console.log("Opening Experience — condition passed ");
  //     handleOpenExperience();
  //     setDirectExperienceCardCreate(false); // Optional: reset it just in case
  //   } else {
  //     console.log("Creating Experience — condition failed ");
  //     setDirectExperienceCardCreate(true);
  //   }
  // }, [ExperienceCard, category]);

  // useEffect(() => {
  //   const shouldOpenEducation =
  //     Array.isArray(EducationCard) &&
  //     EducationCard?.length > 0 &&
  //     (category === "Customize_Student" || category === "Student");

  //   if (shouldOpenEducation) {
  //     handleOpen();
  //     setDirectEducationCardCreate(false);
  //   } else {
  //     setDirectEducationCardCreate(true); // or setDirectStudentCardCreate(true);
  //   }
  // }, [EducationCard, category]);

  // console.log("setDirectExperienceCardCreate", directExperienceCardCreate, "setDirectEducationCardCreate", directEducationCardCreate);

  // console.log("Experiencecard", ExperienceCard);

  // console.log("EducationCardEducationCard", EducationCard);

  const [initialCardDetails, setInitialCardDetails] = useState({});
  const [image, setImage] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [saveHittedFirst, setsaveHitted] = useState(false);
  const [selectedCardEducation, setSelectedCardEducation] = useState({});
  const [selectedCardExperience, setSelectedCardExperience] = useState({});
  const [selectedExperience, setSelectedExperience] = useState(null);
  const [selectedExperienceDomain, setSelectedExperienceDomain] =
    useState(null);
  const [selectedInstitute, setSelectedInstitute] = useState(null);
  const [companySearchTerm, setCompanySearchTerm] = useState(
    cardDetails?.company
  );
  const [cardInstitueSearchItem, setCardInstitueSearchItem] = useState(
    cardDetails?.institute
  );
  const [professionalSearchDomain, setProfessionalSearchDomain] = useState(
    cardDetails?.company_website
  );
  const [studentDomainSearchItem, setStudentDomainSearchItem] = useState(
    cardDetails?.institute_domain
  );
  const [loading, setLoading] = useState(false);

  const [menuItem, setMenuItem] = useState();

  const [searchItems, setSearchItems] = useState([]);
  const { openSnackbar } = useQuantityContext();
  // useEffect(() => {
  //   if (selectedCardEducation) {
  //     setCardDetails((prev) => ({
  //       ...prev,
  //       student_year: selectedCardEducation?.start_year ?? prev.student_year,
  //       student_ending_year: selectedCardEducation?.end_year ?? prev.student_ending_year,
  //       student_currently_pursuing: selectedCardEducation?.is_pursuing ?? prev.student_currently_pursuing,
  //       education_level: selectedCardEducation?.educational_level ?? prev.education_level,
  //       institute: selectedCardEducation?.institute_name ?? prev.institute,
  //       board: selectedCardEducation?.board ?? prev.board,
  //       degree: selectedCardEducation?.degree ?? prev.degree,
  //       field_of_study: selectedCardEducation?.field_of_study ?? prev.field_of_study,
  //       grade: selectedCardEducation?.percentage ?? prev.grade,
  //       summary: selectedCardEducation?.desc ?? prev.summary,
  //       institute_website: selectedCardEducation?.institute_domain ?? prev.institute_website,

  //     }));

  //     updateCardDetails({
  //       logo: selectedCardEducation?.logo_link || '',
  //       board: selectedCardEducation?.institute_name || '',
  //       institute: selectedCardEducation?.board || '',
  //     });
  //     setSelectedUniversity1(selectedCardEducation?.institute_name);
  //     setSelectedUniversity2(selectedCardEducation?.board);
  //   }
  // }, [selectedCardEducation]);

  // useEffect(() => {
  //   if (selectedCardExperience) {
  //     setCardDetails((prev) => ({
  //       ...prev,
  //       employee_id: '',
  //       company_id: '',
  //       profession_department: '',
  //       profession_id: '',
  //       professional_email_id: '',
  //       company_website: selectedCardExperience?.company_domain || prev.company_website,
  //       is_professional_verified: false,
  //       professional_details_status: '',
  //       student_year: '',
  //       student_ending_year: '',
  //       title: '',
  //       summary: selectedCardExperience?.details || prev.summary,
  //       designation: selectedCardExperience?.role_title || prev.designation,
  //       company: selectedCardExperience?.company_name || prev.company,
  //       profession_department: '',

  //     }));

  //     updateCardDetails({
  //       logo: selectedCardExperience?.company_logo || '',

  //     });
  //     // setSelectedUniversity1(selectedCardEducation?.institute_name);
  //     // setSelectedUniversity2(selectedCardEducation?.board);
  //   }
  // }, [selectedCardExperience]);

  // console.log("Selected Eucation:", selectedCardEducation);
  // console.log("Selected Experience:", selectedCardExperience);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState({
    title: "",
    body: "",
  });
  const dispatch = useDispatch();

  const cropperRef = useRef(null);
  const [cropperInitialized, setCropperInitialized] = useState(false);
  const apiKey = process.env.REACT_APP_API_KEY;
  const objectId = localStorage.getItem("objectId");
  const headers = {
    "x-api-key": apiKey,
    "Content-Type": "application/json",
    Authorization: `Bearer ${objectId}`,
  };

  useEffect(() => {
    setInitialCardDetails(cardDetails);
  }, []);

  useEffect(() => {
    setSaveEnable(
      JSON.stringify(initialCardDetails) !== JSON.stringify(cardDetails)
    );
    setisNavigationBlocked(
      JSON.stringify(initialCardDetails) !== JSON.stringify(cardDetails)
    );
  }, [cardDetails, initialCardDetails]);

  const handleInputChange = (fieldName) => (event) => {
    const newValue = event.target.value;
    updateCardDetails({ [fieldName]: newValue });
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const [cardNameError, setCardNameError] = useState("");

  const handleChangeCardName = (event) => {
    if (!/^[a-zA-Z\s]*$/.test(event.target.value)) {
      handleInfo("Card Name should not contains numbers or special characters");
      return;
    }

    if (event.target.value?.length > 18) {
      handleInfo("Card Name must be 18 characters or less.");
      return;
    }

    const newValue = event.target.value;
    setCardNameError("");
    updateCardDetails({ CardName: newValue });
    updateCardStyles({ CardName: newValue });
    updateCardQrStyles({ CardName: newValue });
    updateSocialLinks2({ CardName: newValue });
    updateContactStyles({ CardName: newValue });
    updateAttachDocsVal({ fieldName: "card_name", value: newValue });
  };
  const [selectedFile, setSelectedFile] = useState(null);

  // const handleFileSelect = (event) => {
  //   const file = event.target.files[0];
  //   if (!file) return;

  //   const imageUrl = URL.createObjectURL(file);
  //   setSelectedFile(file);
  //   setSelectedImage(imageUrl);
  //   setOpenDialog(true);
  // };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    event.target.value = "";
    // Remove spaces and parentheses from the file name
    const cleanedFileName = file.name.replace(/\s+/g, "").replace(/[()]/g, "");

    // Create a new File object with the cleaned file name
    const cleanedFile = new File([file], cleanedFileName, { type: file.type });

    const imageUrl = URL.createObjectURL(cleanedFile);
    setSelectedFile(cleanedFile);
    setSelectedImage(imageUrl);
    setOpenDialog(true);
  };

  const handleSearchLogo = (event, newInputValue) => {
    console.log("search Logoggg", newInputValue);

    if (menuItem === "Student") {
      // When typing, only update the institute name, reset logo/domain
      setSelectedInstitute(null); // deselect any previously selected item
      setCardInstitueSearchItem(newInputValue);
      setCardDetails((prev) => ({
        ...prev,
        institute: newInputValue,
        // instlogo: { name: "logo", type: "image/png", data: "" },
        // instituteDomain: ""
      }));
    }
    if (menuItem === "Professional") {
      setSelectedExperience(null);
      setCompanySearchTerm(newInputValue);
      setCardDetails((prev) => ({
        ...prev,
        company: newInputValue,
        // DON’T reset companyDomain here
        // companylogo: { name: "logo", type: "image/png", data: "" },
      }));
    }
  };

  const handleSelected = (event, selectedValue) => {
    console.log("Selected Logo:", selectedValue);
    setSearchItems(null);

    if (menuItem === "Professional") {
      if (!selectedValue) {
        setSelectedExperience(null);
        setCardDetails({
          ...cardDetails,
          company: "",
          company_website: "",
          logo: { name: "logo", type: "image/png", data: "" },
        });
      } else {
        setSelectedExperience(selectedValue);
        setCompanySearchTerm(selectedValue?.legal_name || "");

        setCardDetails({
          ...cardDetails,
          company: selectedValue?.legal_name,
          company_website: selectedValue?.website || "",
          logo: {
            name: "logo",
            type: "image/png",
            data: selectedValue?.logo || "",
          },
        });

        setProfessionalSearchDomain(selectedValue?.website || " ");
      }
    }

    if (menuItem === "Student") {
      if (!selectedValue) {
        setSelectedInstitute(null);
        setCardDetails({
          ...cardDetails,
          institute: "",
          institute_domain: "",
          logo: { name: "logo", type: "image/png", data: "" },
        });
      } else {
        setSelectedInstitute(selectedValue);
        setCardInstitueSearchItem(selectedValue?.legal_name || "");

        setCardDetails({
          ...cardDetails,
          institute: selectedValue?.legal_name,
          institute_domain: selectedValue?.website || "",
          logo: {
            name: "logo",
            type: "image/png",
            data: selectedValue?.logo || "",
          },
        });

        setStudentDomainSearchItem(selectedValue?.website || " ");
      }
    }
  };

  const handleSelectedDomain = (event, selectedvalue) => {
    console.log("SELECTED LOGO", selectedvalue);
    setSearchItems(null);

    if (menuItem === "Student") {
      if (!selectedvalue || typeof selectedvalue === "string") {
        setSelectedExperienceDomain(null);
        setCardDetails({
          ...cardDetails,
          institute: "",
          institute_domain: "",
          logo: { name: "logo", type: "image/png", data: "" },
        });
      } else {
        setSelectedExperienceDomain(selectedvalue);
        setStudentDomainSearchItem(selectedvalue?.website || " ");
        setCardDetails({
          ...cardDetails,
          institute: selectedvalue?.legal_name || "",
          institute_domain: selectedvalue?.website || "",
          logo: {
            name: "logo",
            type: "image/png",
            data: selectedvalue?.logo || "",
          },
        });

        setCardInstitueSearchItem(selectedvalue?.legal_name || "");
      }
    }

    if (menuItem === "Professional") {
      if (!selectedvalue || typeof selectedvalue === "string") {
        setSelectedExperienceDomain(null);
        setCardDetails({
          ...cardDetails,
          company: "",
          company_website: "",
          logo: { name: "logo", type: "image/png", data: "" },
        });
      } else {
        setSelectedExperienceDomain(selectedvalue);
        setProfessionalSearchDomain(selectedvalue?.website || " ");
        setCardDetails({
          ...cardDetails,
          company: selectedvalue?.legal_name || "",
          company_website: selectedvalue?.website || "",
          logo: {
            name: "logo",
            type: "image/png",
            data: selectedvalue?.logo || "",
          },
        });

        setCompanySearchTerm(selectedvalue?.legal_name || "");
      }
    }
  };

  const handleSearchDomain = (event, value) => {
    console.log("search Logoggg", value);

    if (menuItem === "Student") {
      // When typing, only update the institute name, reset logo/domain
      // setSelectedInstituteDomain(null);
      // // deselect any previously selected item]

      setSelectedExperienceDomain(null);
      setStudentDomainSearchItem(value);
      setCardDetails((prev) => ({
        ...prev,
        // institute: "",
        // instlogo: { name: "logo", type: "image/png", data: "" },
        institute_domain: value,
      }));
    }

    if (menuItem === "Professional") {
      setSelectedExperienceDomain(null);
      setProfessionalSearchDomain(value);
      setCardDetails((prev) => ({
        ...prev,
        company_website: value,
        // DON’T reset companyName here
        // companylogo: { name: "logo", type: "image/png", data: "" },
      }));
    }
  };

  useEffect(() => {
    if (!companySearchTerm) {
      // Ensure API is called only when there's a search value
      setSearchItems([]);
      return;
    }
    const delayDebouncing = setTimeout(() => {
      getLogo(companySearchTerm);
    }, 500);
    return () => clearTimeout(delayDebouncing);
  }, [companySearchTerm]);

  useEffect(() => {
    if (!cardInstitueSearchItem) {
      // Ensure API is called only when there's a search value
      setSearchItems([]);
      return;
    }
    const delayDebouncing = setTimeout(() => {
      getEducationLogo(cardInstitueSearchItem);
    }, 500);
    return () => clearTimeout(delayDebouncing);
  }, [cardInstitueSearchItem]);

  useEffect(() => {
    if (!professionalSearchDomain) {
      return;
    }
    const delayDebouncing = setTimeout(() => {
      getLogo(professionalSearchDomain); //  only pass domain
    }, 500);

    return () => clearTimeout(delayDebouncing);
  }, [professionalSearchDomain]);

  useEffect(() => {
    if (!studentDomainSearchItem) {
      return;
    }
    const delayDebouncing = setTimeout(() => {
      getEducationLogo(studentDomainSearchItem); //  only pass domain
    }, 500);

    return () => clearTimeout(delayDebouncing);
  }, [studentDomainSearchItem]);

  const getLogo = async (searchValue) => {
    try {
      const response = await dispatch(getLogoReducer(searchValue));
      console.log("Logo response", response);
      if (response?.payload?.statusCode === 200) {
        setSearchItems(response?.payload?.data);
      }
    } catch (error) {
      console.log("API EROR", error);
    }
  };

  const getEducationLogo = async (searchValue) => {
    try {
      const response = await dispatch(getEducationLogoReducer(searchValue));
      console.log("Logo response", response);
      if (response?.payload?.statusCode === 200) {
        setSearchItems(response?.payload?.data);
      }
    } catch (error) {
      console.log("API EROR", error);
    }
  };

  // const handleInfo = (message = "", autoClose = 5000) => {
  //   let infoMessage;
  //   infoMessage = message;
  //   openSnackbar(infoMessage, "info", autoClose);
  // };

  const handleCropSave = () => {
    console.log("Clicking save button");

    if (!cropperRef.current || !cropperRef.current.getCroppedCanvas) {
      console.error(
        "Cropper not initialized or getCroppedCanvas function not available."
      );
      return;
    }

    const canvas = cropperRef.current.getCroppedCanvas();

    if (canvas) {
      canvas.toBlob((blob) => {
        const croppedFile = new File(
          [blob],
          selectedFile.name || "croppedImage.jpg",
          {
            type: selectedFile.type || "image/jpeg",
          }
        );

        // Update selected image state
        setSelectedImage(URL.createObjectURL(croppedFile));

        // Prepare image object for form data
        const imageObject = {
          name: croppedFile.name,
          type: croppedFile.type,
          data: URL.createObjectURL(croppedFile),
        };
        console.log("CROPPED Image", imageObject);
        // Update form data with cropped image object
        updateCardDetails({ profile_pic: imageObject?.data });

        // Close dialog after cropping
        setOpenDialog(false);

        // Upload the cropped file
        handleFileUpload(croppedFile);
      }, "image/jpeg");
    } else {
      console.error("Canvas not available after cropping.");
    }
  };

  // Function to handle file upload to server
  const handleFileUpload = async (file) => {
    if (!file) {
      console.error("No file to upload.");
      return;
    }

    try {
      // const formData = new FormData();
      // formData.append('file', file);

      // const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/uploadpublicblob/generate-sas-url`, formData, {
      //   headers: {
      //     'Content-Type': 'multipart/form-data',
      //   },
      // });

      // Assuming your response structure is like { sasUrl: 'some_url' }
      // const sasUrl = response.data.url;

      // console.log("File uploaded successfully!", sasUrl);
      const fileUrl = URL.createObjectURL(file);
      updateCardDetails({ profile_pic: fileUrl });
      setSelectedImage(null);
      setSelectedFile(null);
      // Proceed to next step or perform necessary actions after upload
      // setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } catch (error) {
      console.error("Error uploading file:", error.message);
      handleFailure(
        "Error uploading file. Please check the console for details."
      );
    }
  };

  useEffect(() => {
    if (
      openDialog &&
      selectedImage &&
      !cropperInitialized &&
      cropperRef.current
    ) {
      console.log("Initializing cropper...");
      setCropperInitialized(true);
    }
  }, [openDialog, selectedImage, cropperInitialized]);

  // Function to handle cropper initialization
  const handleCropperInitialized = (instance) => {
    cropperRef.current = instance;
  };

  const [expanded, setExpanded] = useState(false);

  const handleSave = async (event) => {
    event.preventDefault();

    const invalidCardNames = ["Personal", "Professional", "Student", "GenZ"];
    if (
      cardDetails?.CardType?.startsWith("Customize_") &&
      (cardDetails.CardName === "" || cardDetails.CardName === null)
    ) {
      handleInfo("CardName should not be Empty");
      return;
    }
    if (
      cards
        .map((card) => card.toLowerCase())
        .includes(cardDetails.CardName.trim().toLowerCase())
    ) {
      setCardNameError("Card name should be unique");
      return;
    }
    if (invalidCardNames.includes(cardDetails.CardName.trim())) {
      setCardNameError("Card name already reserved");
      return;
    }

    if (!/^[a-zA-Z\s]*$/.test(cardDetails.CardName)) {
      setCardNameError(
        "Card Name can only contain alphanumeric characters (no spaces or special characters)."
      );
      return;
    }

    if (cardDetails.CardName > 19) {
      setCardNameError("Card Name must be 19 characters or less.");
      return;
    }

    // if(cardDetails.CardName === '' || cardDetails.CardName === null){
    //   alert("CardName should not be Empty");
    //   return;
    // }

    event.preventDefault();

    const newCardDetails = {
      User_ID: cardDetails.User_ID,
      CardType: cardDetails.CardType,
      // CardName: cardDetails.CardName,
      CardName: cardDetails?.CardType?.startsWith("Customize_")
        ? cardDetails?.CardName || "CardName"
        : cardDetails?.CardType,
      card_mobile: userDetails.phone,
      card_email: userDetails.email,
      created_by: userDetails.name,
    };

    try {
      const updatedCardName = cardDetails?.CardType?.startsWith("Customize_")
        ? cardDetails?.CardName || "CardName"
        : cardDetails?.CardType;

      const updatedCardDetails = {
        ...cardDetails,
        CardName: updatedCardName,
      };

      setCardDetails(updatedCardDetails);
      console.log("CARD DETAILS", cardDetails);
      const formData = new FormData();

      const appendIfDefined = (key, value) => {
        if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      };

      appendIfDefined("User_ID", cardDetails?.User_ID);
      appendIfDefined("CardType", cardDetails?.CardType);
      appendIfDefined("CardName", updatedCardName);
      appendIfDefined("employee_id", cardDetails?.employee_id);
      appendIfDefined("company_id", cardDetails?.company_id);
      appendIfDefined("location", cardDetails?.location);
      appendIfDefined("location_type", cardDetails?.location_type);
      appendIfDefined("details", cardDetails?.summary);
      appendIfDefined("start_month", selectedCardExperience?.start_month || "");
      appendIfDefined("end_month", selectedCardExperience?.end_month || "");
      appendIfDefined("is_currently_working",cardDetails?.is_experience_current === true ? true : true);
      // appendIfDefined('responsibility', cardDetails?.responsibility.join(", "));
      appendIfDefined(
        "responsibility",
        Array.isArray(cardDetails?.responsibility)
          ? cardDetails.responsibility.join(", ")
          : cardDetails?.responsibility || ""
      );

      appendIfDefined("experience_id", selectedCardExperience?.id || "");
      appendIfDefined("desc", cardDetails?.summary);

      appendIfDefined("employee_type", cardDetails?.employee_type || "");
      appendIfDefined("profession_department",cardDetails?.profession_department);
      appendIfDefined("profession_id", cardDetails?.profession_id);
      appendIfDefined("company_website", cardDetails?.company_website);
      appendIfDefined("institute_domain", cardDetails?.institute_domain);
      appendIfDefined("is_professional_verified",cardDetails?.is_professional_verified);
      appendIfDefined("profile_headline", cardDetails?.profile_headline);
      appendIfDefined("professional_details_status",cardDetails?.professional_details_status);
      appendIfDefined("student_id", cardDetails?.student_id);
      appendIfDefined("student_email_id", cardDetails?.student_email_id);
      // appendIfDefined('student_year', cardDetails?.student_year);
      // appendIfDefined('student_year', cardDetails?.student_year);
      // appendIfDefined('student_ending_year', cardDetails?.student_currently_pursuing ? new Date().getFullYear() : cardDetails?.student_ending_year);
      appendIfDefined("end_year",cardDetails?.is_currently_working? new Date().getFullYear(): cardDetails?.end_year);
      appendIfDefined("start_year", cardDetails?.start_year);
      appendIfDefined("student_currently_pursuing",cardDetails?.student_currently_pursuing ? 1 : 1);
      appendIfDefined("educational_level", cardDetails?.education_level);
      appendIfDefined("institute_name", cardDetails?.institute);
      appendIfDefined("board", cardDetails?.board);
      appendIfDefined("degree", cardDetails?.degree);
      appendIfDefined("field_of_study", cardDetails?.field_of_study);
      appendIfDefined("percentage", cardDetails?.grade);
      appendIfDefined("university_website", cardDetails?.university_website);
      appendIfDefined("is_student_verified",cardDetails?.is_student_verified ? 1 : 0);
      appendIfDefined("student_details_status",cardDetails?.student_details_status);
      appendIfDefined("prefix", cardDetails?.prefix);
      appendIfDefined("suffix", cardDetails?.suffix);
      appendIfDefined("title", cardDetails?.title);
      appendIfDefined("nickname", cardDetails?.nickname);
      appendIfDefined("education_id", selectedCardEducation?.id);
      appendIfDefined("summary", cardDetails?.summary);

      appendIfDefined("role_title", cardDetails?.designation);
      appendIfDefined("designation", cardDetails?.designation);
      appendIfDefined("company_name", cardDetails?.company);
      appendIfDefined("professional_email_id",cardDetails?.professional_email_id);

      if (cardDetails?.additionalFields) {
        Object.entries(cardDetails?.additionalFields).forEach(
          ([key, value]) => {
            appendIfDefined(`additionalFields[${key}]`, value);
          }
        );
      }

      if (cardDetails?.profile_pic) {
        try {
          const response = await fetch(cardDetails?.profile_pic);
          const blob = await response.blob();
          appendIfDefined("profile_pic", blob);
        } catch (error) {
          console.log("API Error", error);
        }
      }

      if (cardDetails?.logo) {
        const logoUrl = cardDetails?.logo?.data || cardDetails?.logo;

        if (logoUrl.startsWith("blob:")) {
          setLoading(true);
          handleInfo("Please wait to complete the process");

          try {
            const response = await fetch(logoUrl);
            const blob = await response.blob();
            const file = new File([blob], cardDetails?.logo?.name, {
              type: cardDetails?.logo?.type,
            });
            appendIfDefined("logo_file", blob, cardDetails?.logo?.name);
          } catch (error) {
            console.error("Error fetching File", error);
          }

          setLoading(false);
        } else {
          appendIfDefined("logo", logoUrl);
        }
      }

      if (
        cardDetails?.CardType === "Student" ||
        cardDetails?.CardType === "Customize_Student"
      ) {
        // if (directEducationCardCreate) {
        const response = await dispatch(
          postCreateCardWithNewEducationReducer(formData)
        );

        if (
          response?.payload?.message ===
          "Card created Successfully along with new Student experience"
        ) {
          setIsPersonalDetailsSaved(true);
          await dispatch(getEducationReducer());
          handleSuccess();
        } else {
          handleFailure();
        }
      }

      // for (let [key, value] of formData.entries()) {
      //   console.log(key, value);
      // }

      if (
        cardDetails?.CardType === "Professional" ||
        cardDetails?.CardType === "Customize_Professional"
      ) {
        // if (directExperienceCardCreate) {
        const response = await dispatch(
          postCreateCardWithNewExperienceReducer(formData)
        );

        if (
          response?.payload?.message ===
          "Card created Successfully along with new profile experience"
        ) {
          setIsPersonalDetailsSaved(true);
          await dispatch(getExperienceReducer());
          handleSuccess();
        } else {
          handleFailure("Card detail already exists");
          // handleSuccess("Card");
        }
      }

      if (
        cardDetails?.CardType === "Personal" ||
        cardDetails?.CardType === "Customize_Personal"
      ) {
        try {
          const response2 = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/api/v1/card/addNewCardDetails`,
            newCardDetails,
            {
              headers: headers,
            }
          );
          setIsPersonalDetailsSaved(true);
        } catch (err) {
          console.log("New Card Details already exist or Error occured");
        }

        const response = await dispatch(postCardProfileLogoReducer(formData));
        // console.log("postCreateCardWithNewEducationReducer response", response);
        if (response?.payload?.status === 201) {
          handleSuccess();
        } else {
          handleFailure();
        }
      }
      // await axios.post(`${process.env.REACT_APP_BACKEND_URL}/card/personaldata`, cardDetails, {
      //   headers: headers
      // });
      // console.log('Response from backend:', response);

      setsaveHitted(true);
      setInitialCardDetails(cardDetails);

      dispatch(getAllCardDetailsReducer());
      // console.log("I am Here")
      dispatch(getAllCardInfoReducer());
      dispatch(getVisitingCardReducer(encryptedId));
    } catch (error) {
      console.error("Error submitting card details:", error);
      handleFailure();
    }
  };

  const PhoneInputMenuProps = {
    PaperProps: {
      style: {
        maxHeight: 48 * 4.5, // set the max height for the dropdown menu
        width: "auto", // auto width to match the TextField
      },
    },
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },

    transformOrigin: {
      vertical: "top",
      horizontal: "left",
    },
    getContentAnchorEl: null, // to ensure the menu doesn't move unexpectedly
  };

  const [universities, setUniversities] = useState([]);

  // useEffect(() => {
  //   const fetchUniversityNames = async () => {
  //     try {
  //       const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/card/universities`, {
  //         headers: headers
  //       });
  //       setUniversities(response.data);
  //     } catch (error) {
  //       console.error('Failed to fetch university names:', error);
  //     }
  //   };

  //   fetchUniversityNames();
  // }, [apiKey]);

  // const handleSearchTextChange1 = (event, value) => {
  //   // setSearchText1(value);
  //   setSearchColleges(value);
  //   updateCardDetails({ institute: value.college_name });
  // };

  // const handleUniversityChange1 = (event, value) => {
  //   if (!value) {
  //     setSelectedUniversity1(null);
  //     updateCardDetails({ institute: "" }); // Clear the board/university field in the backend
  //   } else {
  //     setSelectedUniversity1(value);
  //     updateCardDetails({ institute: value.college_name });
  //   }

  //   if (value && value.university_name) {
  //     console.log('Selected option:', value);
  //     setSearchUniversity(value.university_name);
  //     setSelectedUniversity2({ name: value.university_name });
  //     updateCardDetails({ board: value.university_name });
  //   } else {
  //     setSearchUniversity('');
  //     setSelectedUniversity2(null);
  //     updateCardDetails({ board: '' });
  //   }
  // };

  const handleSearchTextChange2 = (event, value) => {
    // setSearchText2(value);
    setSearchUniversity(value);
    updateCardDetails({ board: value.name });
  };

  const handleUniversityChange2 = (event, value) => {
    // Handle null values when the field is cleared
    // console.log("Selected Board", value);
    if (!value) {
      setSelectedUniversity2(null);
      updateCardDetails({ board: "" }); // Clear the board/university field in the backend
    } else {
      setSelectedUniversity2(value);
      updateCardDetails({ board: value.name }); // Use the correct field
    }
  };

  const isCollege =
    cardDetails?.education_level === "UG" ||
    cardDetails?.education_level === "PG" ||
    cardDetails?.education_level === "HigherEd";

  // const uniqueUniversities1 = universities.filter((university) => university.toLowerCase().includes(searchText1.toLowerCase()));
  // const uniqueUniversities2 = universities.filter((university) => university.toLowerCase().includes(searchText2.toLowerCase()));

  // // Ensure unique keys for Autocomplete options
  // const filteredUniversities1 = Array.from(new Set(uniqueUniversities1));
  // const filteredUniversities2 = Array.from(new Set(uniqueUniversities2));

  const dateOfBirth =
    cardDetails && cardDetails?.DOB ? cardDetails?.DOB.split("T")[0] : "";
  const [maxDate, setMaxDate] = useState("");

  useEffect(() => {
    // Set maxDate to today's date in YYYY-MM-DD format
    const today = new Date().toISOString().split("T")[0];
    setMaxDate(today);
  }, []);

  // const handleDOBChange = (event) => {
  //   const dateString = event.target.value;
  //   const dateObject = new Date(dateString);
  //   if (!isNaN(dateObject.getTime())) {
  //     updateCardDetails({ DOB: dateString });
  //   } else {
  //     console.error('Invalid date');
  //   }
  // };

  const handleDOBChange = (dateString) => {
    const dateObject = new Date(dateString);
    if (!isNaN(dateObject.getTime())) {
      setUserDetails((prevDetails) => ({
        ...prevDetails,
        dob: dateString,
      }));

      setCardDetails((prevDetails) => ({
        ...prevDetails,
        dob: dateString,
        isDbavailable: false,
      }));
    } else {
      console.error("Invalid date");
    }
  };

  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;
    updateCardDetails({ student_currently_pursuing: checked });
        updateCardDetails({ is_experience_current: checked });
  };

  // Effect to initialize cropper once selected image changes
  useEffect(() => {
    if (
      openDialog &&
      selectedImage &&
      !cropperInitialized &&
      cropperRef.current
    ) {
      console.log("Initializing cropper...");
      setCropperInitialized(true);
    }
  }, [openDialog, selectedImage, cropperInitialized]);

  // Function to handle cropper initialization
  const getCroppedCanvas = (instance) => {
    cropperRef.current = instance;
  };

  useEffect(() => {
    if (openDialog && selectedImage) {
      setCropperInitialized(false);
    }
  }, [selectedImage]);

  const [openDialogForNewField, setOpenDialogForNewField] = useState(false);
  const [newFieldName, setNewFieldName] = useState("");
  const [newFieldValue, setNewFieldValue] = useState("");

  const handleAddField = () => {
    if (newFieldName && newFieldValue) {
      setCardDetails((prevDetails) => ({
        ...prevDetails,
        additionalFields: {
          ...prevDetails.additionalFields,
          [newFieldName]: newFieldValue,
        },
      }));
      setNewFieldName("");
      setNewFieldValue("");
      setOpenDialogForNewField(false);
    }
  };

  const handleFieldChange = (key, event) => {
    setCardDetails((prevDetails) => ({
      ...prevDetails,
      additionalFields: {
        ...prevDetails.additionalFields,
        [key]: event.target.value,
      },
    }));
  };

  const handleRemoveField = (key) => {
    const { [key]: removedField, ...remainingFields } =
      cardDetails.additionalFields;
    setCardDetails((prevDetails) => ({
      ...prevDetails,
      additionalFields: remainingFields,
    }));
  };

  // Integrating new Colleges List API
  const [searchColleges, setSearchColleges] = useState(cardDetails?.institute);
  const [filteredColleges, setFilteredColleges] = useState([]);
  const [searchUniversity, setSearchUniversity] = useState(cardDetails?.board);
  const [filteredUniversities, setFilteredUniversities] = useState([]);
  const [offset, setOffset] = useState({
    colleges: 0,
    universities: 0,
  });
  const [hasMoreItems, setHasMoreItems] = useState({
    colleges: true,
    universities: true,
  }); // To track if more results are available
  const limit = 20;

  const fetchCollegesList = async () => {
    try {
      const reqObject = {
        search: searchColleges,
        limit: limit,
        offset: offset.colleges,
      };
      const response = await callApiFunction("getCollegesList", reqObject);

      if (response.status === "SUCCESS") {
        const allColleges = response.data.colleges;

        // If less than 20 colleges are fetched, no more data is available
        if (allColleges?.length < limit) {
          setHasMoreItems((prevState) => ({ ...prevState, colleges: false }));
        }

        setFilteredColleges((prevColleges) => [
          ...prevColleges,
          ...allColleges,
        ]);
      } else {
        console.error("Failed to fetch college data.");
      }
    } catch (err) {
      console.error("An error occurred while fetching college data.", err);
    }
  };

  // const fetchUniversitiesList = async () => {
  //   try {
  //     const reqObject = {
  //       search: searchUniversity,
  //       limit: limit,
  //       offset: offset.universities
  //     };
  //     const response = await callApiFunction('getUniversitiesList', reqObject);

  //     if (response.status === "SUCCESS") {
  //       const allUniversities = response.data.universities;

  //       // If less than 20 colleges are fetched, no more data is available
  //       if (allUniversities?.length < limit) {
  //         setHasMoreItems(prevState => ({ ...prevState, universities: false }));
  //       }

  //       setFilteredUniversities(prevUniversities => [...prevUniversities, ...allUniversities]);
  //     } else {
  //       console.error('Failed to fetch University data.');
  //     }
  //   } catch (err) {
  //     console.error('An error occurred while fetching university data.', err);
  //   }
  // };

  // Scroll event handler to detect if the user has reached the bottom of the dropdown

  const fetchUniversitiesList = async () => {
    const localStorageKey = "universities_Listdata";

    try {
      // Check LocalStorage first
      const storedData = localStorage.getItem(localStorageKey);
      if (storedData) {
        setFilteredUniversities(JSON.parse(storedData));
        setHasMoreItems((prevState) => ({ ...prevState, universities: false }));
        return;
      }

      // Fetch from API
      const response = await callApiFunction("getUniversitiesList", {
        limit: 3000,
        offset: 0,
      });
      console.log("universities data", response);
      if (response.status === "SUCCESS") {
        const newUniversities = response.data.universities;
        console.log("universities data", newUniversities);
        // Store in LocalStorage
        const storedData = localStorage.getItem(localStorageKey);
        const parsedData = storedData ? JSON.parse(storedData) : [];
        const updatedData = [...parsedData, ...newUniversities];
        localStorage.setItem(localStorageKey, JSON.stringify(updatedData));

        // Update State
        setFilteredUniversities((prevUniversities) => [
          ...prevUniversities,
          ...newUniversities,
        ]);

        // Check if more data is available
        if (newUniversities?.length < 3000) {
          setHasMoreItems((prevState) => ({
            ...prevState,
            universities: false,
          }));
        }
      } else {
        console.error("Failed to fetch University data.");
      }
    } catch (err) {
      console.error("An error occurred while fetching university data.", err);
    }
  };

  const handleDropdownScroll = (event, listName = "colleges") => {
    const bottom =
      event.target.scrollHeight - event.target.scrollTop ===
      event.target.clientHeight;

    if (bottom && hasMoreItems[listName]) {
      // Increment the offset for the correct list (colleges or universities)
      setOffset((prevOffset) => ({
        ...prevOffset,
        [listName]: prevOffset[listName] + limit, // Increment the correct offset key
      }));
    }
  };

  // useEffect to trigger fetch when the offset changes (pagination)
  // useEffect(() => {
  //   if (offset.colleges === 0) return; // Don't fetch data initially unless there's a search
  //   fetchCollegesList();
  // }, [offset.colleges]); // Trigger fetch when colleges offset changes

  useEffect(() => {
    if (offset.universities === 0) return; // Don't fetch data if no search term
    fetchUniversitiesList();
  }, [offset.universities]);

  // useEffect for when College search term changes
  // useEffect(() => {
  //   const debounceSearch = setTimeout(() => {
  //     setFilteredColleges([]); // Clear previous results
  //     setOffset(prevOffset => ({ ...prevOffset, colleges: 0 })); // Reset offset for new search
  //     setHasMoreItems(prevState => ({ ...prevState, colleges: true })); // Reset hasMoreItems flag
  //     fetchCollegesList(); // Initial fetch for new search term
  //   }, 300);

  //   return () => clearTimeout(debounceSearch);
  // }, [searchColleges]);

  // useEffect for when Universities search term changes
  useEffect(() => {
    const debounceSearch = setTimeout(() => {
      setFilteredUniversities([]); // Clear previous results
      setOffset((prevOffset) => ({ ...prevOffset, universities: 0 })); // Reset offset for new search
      setHasMoreItems((prevState) => ({ ...prevState, universities: true })); // Reset hasMoreItems flag
      fetchUniversitiesList();
    }, 300);

    return () => clearTimeout(debounceSearch);
  }, [searchUniversity]);

  console.log(
    "student_currently_pursuing:",
    cardDetails?.student_currently_pursuing
  );
  console.log("is_pursuing:", selectedCardEducation?.is_pursuing);

  const getPromptData = (cardType) => {
    switch (cardType) {
      case "Personal":
      case "Customize_Personal":
        return {
          name: userDetails.name,
          title: cardDetails?.title,
          nickName: cardDetails?.nickname,
          summary: cardDetails?.summary,
        };

      case "Professional":
      case "Customize_Professional":
        return {
          name: userDetails.name,
          company: cardDetails?.company,
          designation: cardDetails?.role_title,
          department: cardDetails?.profession_department,
          summary: cardDetails?.summary,
        };
      case "Student":
      case "Customize_Student":
        return {
          name: userDetails.name,
          title: cardDetails?.title,
          educationLevel: cardDetails?.education_level,
          institute: cardDetails?.institute,
          boardOrUniversity: cardDetails?.board,
          fieldOfStudy: cardDetails?.field_of_study,
          "Result Grade or Percentage": cardDetails?.grade,
          "Currently Pursuing?": cardDetails?.student_currently_pursuing,
          summary: cardDetails?.summary,
        };
    }
  };

  function getCardTypeForPrompt(cardType) {
    switch (cardType) {
      case "Personal":
      case "Customize_Personal":
        return "Personal";
      case "Professional":
      case "Customize_Professional":
        return "Professional";
      case "Student":
      case "Customize_Student":
        return "Student";
    }
  }

  const canGenerateSummary = () => {
    const { CardType } = cardDetails;
    const type = CardType?.toLowerCase();

    switch (type) {
      case "personal":
      case "customize_personal":
        return Boolean(
          cardDetails?.title || cardDetails?.nickname || cardDetails?.summary
        );

      case "professional":
      case "customize_professional":
        return Boolean(
          cardDetails?.company ||
          cardDetails?.role_title ||
          cardDetails?.profession_department ||
          cardDetails?.summary
        );

      case "student":
      case "customize_student":
        return Boolean(
          cardDetails?.education_level ||
          cardDetails?.institute ||
          cardDetails?.field_of_study ||
          cardDetails?.grade ||
          cardDetails?.summary
        );

      default:
        return false;
    }
  };

  const handleGenerateSummary = async () => {
    try {
      handleInfo("Generating your content...");
      const reqBody = {
        prompt: getPromptData(cardDetails.CardType),
        cardType: getCardTypeForPrompt(cardDetails.CardType),
      };
      const response = await API.post(
        "/api/v1/openai/generate-card-summary",
        reqBody
      );
      const responseData = response.data;
      if (responseData?.statusCode === 200) {
        updateCardDetails({
          summary: responseData?.data?.summary,
        });
        handleSuccess("Content successfully generated!");
      }
    } catch (error) {
      console.error("Error generating description:", error);
      handleFailure("Failed to generate. Please try later.");
    }
  };

  return (
    <div>
      <div style={{ paddingRight: "16px", paddingLeft: "16px" }}>
        <div className="card-edit-info-heading">
          <h5>Profile Information</h5>
          <span>
            Add your profile information to show in your digital business card
          </span>
        </div>
        <div className="profile-and-logo my-4 mt-4">
          <div className="profile-picture-container text-center">
            <h5>Profile Picture</h5>
            <div>
              <Badge
                overlap="circular"
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                badgeContent={
                  <Avatar sx={{ bgcolor: "#0044C6" }}>
                    <label
                      htmlFor="profilePicture-input"
                      style={{ cursor: "pointer" }}
                    >
                      <EditRoundedIcon />
                    </label>
                    <input
                      id="profilePicture-input"
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={handleFileSelect}
                    />
                  </Avatar>
                }
              >
                <Avatar
                  sx={{ bgcolor: "#F4F7FE", width: "130px", height: "130px" }}
                >
                  {cardDetails.profile_pic !== "" ? (
                    <img
                      src={cardDetails.profile_pic}
                      alt="profilepicture"
                      className="profile-pic-avatar"
                    />
                  ) : (
                    <InsertPhotoIcon sx={{ color: "grey" }} fontSize="large" />
                  )}
                </Avatar>
              </Badge>
            </div>
          </div>
          {!(
            cardDetails?.CardType === "Personal" ||
            cardDetails?.CardType === "Customize_Personal"
          ) && (
              <FileDragUpload
                label="Add Logo"
                contextKey="logo"
                accept={["image/jpeg", "image/png"]}
                maxSize={1}
                inputId="companyLogo-input"
                useContext={useCreateCardDetailContext}
              />
            )}
        </div>

        <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
          <DialogTitle>Crop Image</DialogTitle>
          <DialogContent>
            <div
              style={{ width: "100%", height: "400px", position: "relative" }}
            >
              <Cropper
                ref={cropperRef}
                src={selectedImage}
                style={{ height: "100%", width: "100%" }}
                initialAspectRatio={1}
                guides={true}
                cropBoxMovable={true}
                cropBoxResizable={true}
                crossOrigin="anonymous"
                dragMode="crop"
                viewMode={1}
                background={false}
                responsive={true}
                autoCrop={false}
                autoCropArea={1}
                minCropBoxHeight={20}
                minCropBoxWidth={20}
                checkOrientation={false}
                onInitialized={handleCropperInitialized}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCropSave}>Save</Button>
          </DialogActions>
        </Dialog>

        {/* <Dialog open={open} maxWidth="xs" fullWidth>
          <DialogTitle>Institutes</DialogTitle>
          <DialogContent>
            <Stack spacing={2} mt={1}>
              {EducationCard.map((edu) => (
                <Button
                  onClick={() => (setSelectedCardEducation(edu), handleClose())}
                  key={edu.id}
                  variant="outlined"
                  fullWidth
                  sx={{
                    backgroundColor: "#0044c6",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "#0044c6",
                    },
                  }}
                >
                  {edu.institute_name}
                </Button>
              ))}
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => (handleClose(), setDirectEducationCardCreate(true))} variant="outlined"
              fullWidth
              sx={{
                marginLeft: "20px",
                marginRight: "20px",
                border: "1px solid #0044c6",
                color: "#0044c6",
                "&:hover": {
                  backgroundColor: "white",
                },
              }} >
              Create New card
            </Button>
          </DialogActions>
        </Dialog> */}

        {/* <Dialog open={openExperience} maxWidth="xs" fullWidth>
          <DialogTitle>Experiences</DialogTitle>
          <DialogContent>
            <Stack spacing={2} mt={1}>
              {ExperienceCard.map((experience) => (
                <Button
                  onClick={() => (setSelectedCardExperience(experience), handleCloseExperience())}
                  key={experience.id}
                  variant="outlined"
                  fullWidth
                  sx={{
                    backgroundColor: "#0044c6",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "#0044c6",
                    },
                  }}
                >
                  {experience?.company_name}
                </Button>
              ))}
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => (handleCloseExperience(), setDirectExperienceCardCreate(true))} variant="outlined"
              fullWidth
              sx={{
                marginLeft: "20px",
                marginRight: "20px",
                border: "1px solid #0044c6",
                color: "#0044c6",
                "&:hover": {
                  backgroundColor: "white",
                },
              }} >
              Create New card
            </Button>
          </DialogActions>
        </Dialog> */}

        <div className="my-2 user-details-container">
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Grid container direction="column" spacing={2}>
                <Grid item>
                  <FormControl fullWidth>
                    <TextField
                      name="Category"
                      label="Category"
                      required
                      select
                      value={cardDetails?.CardType}
                      InputLabelProps={{ required: false }}
                      fullWidth
                      className="textfield-widthNew"
                      disabled
                      style={{ marginBottom: "16px" }} // Add space here
                    >
                      <MenuItem value="Personal">Personal</MenuItem>
                      <MenuItem value="Professional">Professional</MenuItem>
                      <MenuItem value="Student">Student</MenuItem>
                      <MenuItem value="GenZ">GenZ</MenuItem>
                      <MenuItem value="Customize_Personal">Customize</MenuItem>
                      <MenuItem value="Customize_Professional">
                        Customize
                      </MenuItem>
                      <MenuItem value="Customize_Student">Customize</MenuItem>
                      <MenuItem value="Customize_GenZ">Customize</MenuItem>
                    </TextField>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Grid container direction="column" spacing={2}>
                <Grid item>
                  {cardDetails?.CardType?.startsWith("Customize_") && (
                    <TextField
                      label="Card Name"
                      fullWidth
                      value={cardDetails?.CardName}
                      onChange={handleChangeCardName}
                      disabled={saveHittedFirst}
                      inputProps={{ maxLenght: 18 }}
                    />
                  )}
                  {cardNameError && (
                    <Typography variant="body2" color="error">
                      {cardNameError}
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>

        <div className="my-2 user-details-container">
          <Grid container spacing={2}>
            {/* First Column */}
            <Grid item xs={6}>
              <Grid container direction="column" spacing={2}>
                <Grid item>
                  <TextField
                    value={firstName}
                    label="First Name"
                    fullWidth
                    disabled
                    inputProps={{ maxLenght: 90 }}
                  />
                </Grid>
                <Grid item>
                  <TextField
                    label="Date of Birth"
                    type="date"
                    value={userDetails?.dob}
                    onChange={(event) => handleDOBChange(event.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      inputProps: {
                        max: maxDate, // Set the max attribute dynamically
                      },
                    }}
                    fullWidth
                    disabled={Boolean(userDetails?.dob)}
                  />
                </Grid>
                <Grid item>
                  <TextField
                    label="Suffix"
                    fullWidth
                    value={cardDetails?.suffix}
                    onChange={handleInputChange("suffix")}
                    inputProps={{ maxLength: 6 }}
                  />
                </Grid>
                <Grid item>
                  {cardDetails?.CardType === "Personal" ||
                    cardDetails?.CardType === "Customize_Personal" ? (
                    <TextField
                      label="Title"
                      fullWidth
                      value={cardDetails?.title}
                      onChange={handleInputChange("title")}
                      inputProps={{ maxLenght: 22 }}
                    />
                  ) : cardDetails?.CardType === "Professional" ||
                    cardDetails?.CardType === "Customize_Professional" ? (
                    <TextField
                      label="Department"
                      fullWidth
                      value={cardDetails?.profession_department}
                      onChange={handleInputChange("profession_department")}
                      inputProps={{ maxLength: 30 }}
                    />
                  ) : cardDetails?.CardType === "Student" ||
                    cardDetails?.CardType === "Customize_Student" ? (
                    <FormControl fullWidth>
                      <TextField
                        name="Education"
                        label="Education Level"
                        required
                        select
                        value={(
                          cardDetails?.education_level ||
                          selectedCardEducation?.educational_level ||
                          ""
                        ).toString()}
                        onChange={handleInputChange("education_level")}
                        fullWidth
                        className="textfield-widthNew"
                      >
                        <MenuItem value="SSLC">10th/SSLC/SSC</MenuItem>
                        <MenuItem value="HSC">12th/PUC/HSC</MenuItem>
                        <MenuItem value="UG">Undergraduate</MenuItem>
                        <MenuItem value="PG">Post Graduate</MenuItem>
                        <MenuItem value="HigherEd">Higher Education</MenuItem>
                      </TextField>
                    </FormControl>
                  ) : null}
                </Grid>
                {cardDetails?.CardType === "Student" ||
                  cardDetails?.CardType === "Customize_Student" ? (
                  <>
                    <Grid item>
                      <FormControl fullWidth>
                        <Autocomplete
                          value={selectedInstitute}
                          freeSolo
                          options={searchItems || []}
                          inputValue={cardInstitueSearchItem || ""}
                          onInputChange={(event, value) => {
                            setMenuItem("Student"); // Set correct menu context
                            handleSearchLogo(event, value); // Same search logic
                          }}
                          onChange={(event, value) =>
                            handleSelected(event, value)
                          } // Reuse the same handler
                          getOptionLabel={(option) =>
                            typeof option === "string"
                              ? option
                              : option?.legal_name || ""
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Institute"
                              variant="outlined"
                              fullWidth
                              required
                            // error={eduErrors?.institute}
                            />
                          )}
                        />
                      </FormControl>
                    </Grid>
                    {cardDetails.education_level !== "SSLC" && (
                      <Grid item>
                        <TextField
                          label={
                            cardDetails.education_level === "HSC"
                              ? "Subjects"
                              : "Field of Study"
                          }
                          value={(
                            cardDetails.field_of_study ||
                            selectedCardEducation?.field_of_study ||
                            ""
                          ).toString()}
                          onChange={handleInputChange("field_of_study")}
                          fullWidth
                          inputProps={{ maxLength: 90 }}
                        />
                      </Grid>
                    )}
                    <Grid item>
                      <TextField
                        label="Student ID"
                        fullWidth
                        value={cardDetails.student_id}
                        onChange={handleInputChange("student_id")}
                        inputProps={{ maxLength: 18 }}
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        label="Starting Year"
                        fullWidth
                        value={(cardDetails.start_year || "").toString()}
                        onChange={handleInputChange("start_year")}
                      />
                    </Grid>
                    <Grid item>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={!!cardDetails.student_currently_pursuing}
                            onChange={handleCheckboxChange}
                          />
                        }
                        label="Currently Pursuing"
                      />
                    </Grid>
                  </>
                ) : null}
              </Grid>
            </Grid>

            {/* Second Column */}
            <Grid item xs={6}>
              <Grid container direction="column" spacing={2}>
                <Grid item>
                  <TextField
                    value={lastName}
                    label="Last Name"
                    disabled
                    fullWidth
                    inputProps={{ maxLenght: 90 }}
                  />
                </Grid>

                <Grid item>
                  <TextField
                    label="Prefix"
                    fullWidth
                    value={cardDetails?.prefix}
                    onChange={handleInputChange("prefix")}
                    inputProps={{ maxLength: 5 }}
                  />
                </Grid>

                <Grid item>
                  {cardDetails?.CardType === "Personal" ||
                    cardDetails?.CardType === "Customize_Personal" ? (
                    <TextField
                      label="Personal Email"
                      disabled
                      fullWidth
                      value={userDetails.email}
                      inputProps={{ maxLenght: 48 }}
                    />
                  ) : cardDetails?.CardType === "Professional" ||
                    cardDetails?.CardType === "Customize_Professional" ? (
                    // <TextField label="Company" fullWidth value={cardDetails?.company} onChange={handleInputChange('company')} inputProps={{ maxLenght: 42 }} />
                    // <FormControl fullWidth>
                    //   <Autocomplete
                    //     freeSolo
                    //     options={searchItems}
                    //     value={selectedExperience}
                    //     inputValue={cardDetails?.company || ""}
                    //     onInputChange={handleSearchLogo} // This updates searchQuery
                    //     onChange={handleSelected}
                    //     getOptionLabel={(option) =>
                    //       typeof option === "string" ? option : option?.legal_name || ""
                    //     }
                    //     renderInput={(params) => (
                    //       <TextField
                    //         {...params}
                    //         label="Company"
                    //         variant="outlined"
                    //         fullWidth
                    //         onClick={() => {
                    //           setMenuItem("Professional"); //  This is where you set it
                    //         }}
                    //       />
                    //     )}
                    //   />
                    // </FormControl>

                    <Autocomplete
                      freeSolo
                      options={searchItems || []}
                      value={selectedExperience}
                      inputValue={companySearchTerm}
                      onInputChange={handleSearchLogo}
                      onChange={handleSelected}
                      getOptionLabel={(option) =>
                        typeof option === "string"
                          ? option
                          : option?.legal_name || ""
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Company"
                          variant="outlined"
                          fullWidth
                          onClick={() => {
                            setMenuItem("Professional");
                          }}
                        />
                      )}
                    />
                  ) : cardDetails?.CardType === "Student" ||
                    cardDetails?.CardType === "Customize_Student" ? (
                    <TextField
                      label="Title"
                      fullWidth
                      value={cardDetails?.title}
                      onChange={handleInputChange("title")}
                      inputProps={{ maxLenght: 42 }}
                    />
                  ) : null}
                </Grid>
                <Grid item>
                  {cardDetails?.CardType === "Personal" ||
                    cardDetails?.CardType === "Customize_Personal" ||
                    cardDetails?.CardType === "Student" ||
                    cardDetails?.CardType === "Customize_Student" ? (
                    <TextField
                      label="Nickname"
                      fullWidth
                      value={cardDetails?.nickname}
                      onChange={handleInputChange("nickname")}
                      inputProps={{ maxLenght: 18 }}
                    />
                  ) : cardDetails?.CardType === "Professional" ||
                    cardDetails?.CardType === "Customize_Professional" ? (
                    <TextField
                      label="Role Title"
                      fullWidth
                      value={cardDetails?.designation}
                      onChange={handleInputChange("designation")}
                      inputProps={{ maxLenght: 40 }}
                    />
                  ) : cardDetails?.CardType === "Student" ||
                    cardDetails?.CardType === "Customize_Student" ? (
                    <FormControl fullWidth>
                      <Autocomplete
                        value={selectedUniversity2}
                        onChange={handleUniversityChange2}
                        inputValue={searchUniversity}
                        onInputChange={handleSearchTextChange2}
                        options={isCollege ? filteredUniversities : []}
                        freeSolo
                        // getOptionLabel={(option) => (option ? option.name : "")}
                        getOptionLabel={(option) => {
                          if (typeof option === "string") return option;
                          return option?.name || "";
                        }}
                        ListboxProps={{
                          onScroll: (event) =>
                            handleDropdownScroll(event, "universities"),
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Board/University"
                            variant="outlined"
                            fullWidth
                          />
                        )}
                      />
                    </FormControl>
                  ) : null}
                </Grid>
                {cardDetails?.CardType === "Student" ||
                  cardDetails?.CardType === "Customize_Student" ? (
                  <>
                    {cardDetails.education_level !== "SSLC" &&
                      selectedCardEducation?.educational_level !== "SSLC" && (
                        <Grid item>
                          <TextField
                            label={
                              (cardDetails.education_level ||
                                selectedCardEducation?.educational_level ||
                                "") === "HSC"
                                ? "Stream"
                                : "Degree"
                            }
                            value={(
                              cardDetails.degree ||
                              selectedCardEducation?.degree ||
                              ""
                            ).toString()}
                            onChange={handleInputChange("degree")}
                            fullWidth
                            inputProps={{ maxLength: 48 }}
                          />
                        </Grid>
                      )}
                    <Grid item>
                      <TextField
                        label="Grade/GPA"
                        value={(
                          cardDetails.grade ||
                          selectedCardEducation?.percentage ||
                          ""
                        ).toString()}
                        onChange={handleInputChange("grade")}
                        fullWidth
                        inputProps={{ maxLenght: 18 }}
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        label="Student Email ID"
                        fullWidth
                        value={cardDetails.student_email_id}
                        onChange={handleInputChange("student_email_id")}
                        inputProps={{ maxLenght: 48 }}
                      />
                    </Grid>
                    <Grid item>
                      {/* <TextField
                        label="Ending Year"
                        fullWidth
                        value={(cardDetails.student_ending_year || selectedCardEducation?.end_year || "").toString()}
                        onChange={handleInputChange('student_ending_year')}
                        disabled={cardDetails?.student_currently_pursuing || selectedCardEducation?.is_pursuing}
                      /> */}

                      {cardDetails?.student_currently_pursuing ? (
                        <TextField
                          label="Ending Year"
                          fullWidth
                          value="Present"
                          disabled
                          InputProps={{
                            style: { color: "black" }, // optional
                          }}
                        />
                      ) : (
                        <TextField
                          label="Ending Year"
                          fullWidth
                          type="number"
                          inputProps={{
                            min: 1900,
                            max: new Date().getFullYear(),
                          }}
                          value={cardDetails?.end_year || ""}
                          onChange={handleInputChange("end_year")}
                        />
                      )}
                    </Grid>
                  </>
                ) : null}
              </Grid>
            </Grid>
            {(cardDetails?.CardType === "Personal" ||
              cardDetails?.CardType === "Customize_Personal") && (
                <Grid item xs={6}>
                  <TextField
                    label="Website"
                    fullWidth
                    value={(
                      cardDetails?.company_website ||
                      selectedCardEducation?.institute_domain ||
                      cardDetails?.institute_website ||
                      ""
                    ).toString()}
                    onChange={handleInputChange("company_website")}
                  />
                </Grid>
              )}

            {(cardDetails?.CardType === "Professional" ||
              cardDetails?.CardType === "Customize_Professional") && (
                <>
                  <Grid item xs={6}>
                    <FormControl fullWidth>
                      <Autocomplete
                        freeSolo
                        options={searchItems || []}
                        value={selectedExperienceDomain}
                        inputValue={professionalSearchDomain || ""}
                        onInputChange={handleSearchDomain} // This updates searchQuery
                        onChange={handleSelectedDomain}
                        getOptionLabel={(option) =>
                          typeof option === "string"
                            ? option
                            : option?.website || ""
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="Website"
                            label="Website"
                            variant="outlined"
                            fullWidth
                            onClick={() => {
                              setMenuItem("Professional"); //  This is where you set it
                            }}
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      name="location"
                      label="Location"
                      required
                      className="course-name"
                      fullWidth
                      value={cardDetails?.location}
                      // onChange={handleExperienceItems("location")}
                      onChange={handleInputChange("location")}
                    // error={expErrors?.location}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <FormControl
                      fullWidth
                      required
                    // error={expErrors?.locationType}
                    >
                      <TextField
                        name="locationType"
                        label="Location Type"
                        select
                        value={cardDetails?.location_type}
                        // onChange={handleExperienceItems("locationType")}
                        onChange={handleInputChange("location_type")}
                        InputLabelProps={{ required: false }}
                        fullWidth
                        className="textfield-widthNew"
                      >
                        <MenuItem value="Onsite">Onsite</MenuItem>
                        <MenuItem value="Hybrid">Hybrid</MenuItem>
                        <MenuItem value="Remote">Remote</MenuItem>
                      </TextField>
                    </FormControl>
                  </Grid>

                  <Grid item xs={6}>
                    <FormControl
                      fullWidth
                      required
                    // error={expErrors?.employmentType}
                    >
                      <TextField
                        name="employmentType"
                        label="Employment Type"
                        select
                        value={cardDetails?.employee_type}
                        // onChange={handleExperienceItems("employmentType")}
                        onChange={handleInputChange("employee_type")}
                        InputLabelProps={{ required: false }}
                        fullWidth
                        className="textfield-widthNew"
                      >
                        <MenuItem value="Full-time">Full-time</MenuItem>
                        <MenuItem value="Part-time">Part-time</MenuItem>
                        <MenuItem value="Freelance">Freelance</MenuItem>
                        <MenuItem value="Internship">Internship</MenuItem>
                        <MenuItem value="Trainee">Trainee</MenuItem>
                      </TextField>
                    </FormControl>
                  </Grid>

                  <Grid item xs={6}>
                    <FormControl
                      fullWidth
                      required
                    // error={expErrors?.startYear}
                    >
                      <InputLabel id="start-year-label">Start Year</InputLabel>
                      <Select
                        labelId="year-label"
                        value={cardDetails?.start_year || ""}
                        // onChange={handleExperienceItems("startYear")}
                        onChange={handleInputChange("start_year")}
                        label="Start year"
                        className="text-left"
                        required
                      >
                        {years?.map((year, index) => (
                          <MenuItem key={index} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <Grid item xs={12}>
                      <FormControlLabel fullWidth
                        control={
                          <Checkbox
                            checked={!!cardDetails.is_experience_current}
                            onChange={handleCheckboxChange}
                          />
                        }
                        label="Currently working"
                      />
                    </Grid>

                    <Grid item xs={12} className="my-3">
                      <Autocomplete
                        freeSolo
                        options={kpiOptions}
                        multiple
                        PaperComponent={customHealthPaper}
                        value={
                          Array.isArray(cardDetails?.responsibility)
                            ? cardDetails.responsibility
                            : typeof cardDetails?.responsibility === "string"
                              ? cardDetails.responsibility
                                .split(",")
                                .map((item) => item.trim())
                              : []
                        }
                        onChange={(event, newValue) =>
                          updateCardDetails({
                            ...cardDetails,
                            responsibility: newValue || [],
                          })
                        }
                        inputValue={responsibilityInput}
                        onInputChange={(event, newInputValue) => {
                          setResponsibilityInput(newInputValue); // Update the input value
                        }}
                        onKeyDown={(event) =>
                          handleAddChip(
                            event,
                            responsibilityInput,
                            "responsibility"
                          )
                        }
                        renderTags={(value, getTagProps) =>
                          value?.map((option, index) => (
                            <CustomChip
                              key={index}
                              variant="outlined"
                              label={option}
                              onDelete={() =>
                                handleDeleteChip("responsibility", option)
                              }
                              {...getTagProps({ index })}
                            />
                          ))
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            label="Responsibilities"
                          // placeholder="Your Key Responsibilities"
                          />
                        )}
                      />
                    </Grid>
                  </Grid>

                  <Grid item xs={6}>
                    <FormControl
                      fullWidth
                      required
                    // error={
                    //   expErrors?.endYear ||
                    //   expErrors?.endMonthInvalid ||
                    //   expErrors?.endYearInvalid
                    // }
                    >
                      <InputLabel id="end-year-label">End Year</InputLabel>
                      <Select
                        labelId="year-label"
                        value={cardDetails?.end_year || ""}
                        // onChange={handleExperienceItems("endYear")}
                        onChange={handleInputChange("end_year")}
                        label="End year"
                        className="text-left"
                        disabled={cardDetails?.is_experience_current}
                      >
                        {cardDetails?.is_experience_current && (
                          <MenuItem value="Present">Present</MenuItem>
                        )}
                        {years?.map((year, index) => (
                          <MenuItem key={index} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <Box height={58} />


                    <Grid className="my-6">
                      <TextField
                        label="Profile headline"
                        fullWidth
                        value={cardDetails?.profile_headline}
                        onChange={handleInputChange("profile_headline")}
                        inputProps={{ maxLength: 30 }}
                      />
                      {/* <Grid item xs={12}> */}
                    </Grid>
                  </Grid>
                </>
              )}

            {(cardDetails?.CardType === "Student" ||
              cardDetails?.CardType === "Customize_Student") && (
                <Grid item xs={6}>
                  {/* <TextField label="Website" fullWidth value={(cardDetails?.company_website || selectedCardEducation?.institute_domain || cardDetails?.institute_website || "").toString()} onChange={handleInputChange('company_website')} />
                 */}

                  <FormControl fullWidth>
                    <Autocomplete
                      freeSolo
                      options={searchItems || []}
                      value={selectedExperienceDomain}
                      inputValue={studentDomainSearchItem || ""}
                      onInputChange={handleSearchDomain} // This updates searchQuery
                      onChange={handleSelectedDomain}
                      getOptionLabel={(option) =>
                        typeof option === "string"
                          ? option
                          : option?.website || ""
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="companyDomain"
                          label="Website"
                          variant="outlined"
                          fullWidth
                          onClick={() => {
                            setMenuItem("Student"); //  This is where you set it
                          }}
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
              )}

            {/* <Grid item xs={6}>
                  <TextField label="University Website" fullWidth value={cardDetails?.university_website} onChange={handleInputChange('university_website')} />
                </Grid> */}

            <Grid item xs={12}>
              <Grid item>
                <TextField
                  multiline
                  label="Description"
                  className="summary-field"
                  fullWidth
                  value={(cardDetails?.summary).toString()}
                  onChange={handleInputChange("summary")}
                  inputProps={{ maxLength: 2000 }}
                />
                {/* {(cardDetails?.CardType === "Student" || cardDetails?.CardType === "Customize_Student" || cardDetails?.CardType === "Professional" || cardDetails?.CardType === "Customize_Professional") &&  */}
                <div className="d-flex justify-content-end align-items-start my-2">
                  {/* <div className="invite-modal-subtitle">Enable AI Generation with minimum 15 words</div> */}
                  <Button
                    variant="outlined"
                    sx={{ color: "#0044C6" }}
                    className="ai-rewrite-button"
                    onClick={handleGenerateSummary}
                    disabled={!canGenerateSummary()}
                    startIcon={<AiLogo />}
                  >
                    Generate
                  </Button>
                </div>
                {/* } */}
              </Grid>
            </Grid>

            {Object.keys(cardDetails?.additionalFields ?? {}).map((key) => (
              <Grid item xs={6} key={key}>
                <Grid item>
                  <TextField
                    label={key} // Display the field name
                    value={cardDetails.additionalFields[key]} // Display the field value
                    onChange={(event) => handleFieldChange(key, event)}
                    fullWidth
                  />
                </Grid>
              </Grid>
            ))}
          </Grid>
          {/* </Grid> */}

          {cardDetails?.CardType?.startsWith("Customize_") && (
            <div
              className="my-2 py-2 d-flex align-items-center color-blue"
              onClick={() => setOpenDialogForNewField(true)}
            >
              <div className={`icon me-1 ms-0`}>
                <FaPlusCircle className="color-blue" />
              </div>
              Add More Fields
            </div>
          )}
        </div>
      </div>
      <div>
        <Dialog
          open={openDialogForNewField}
          onClose={() => setOpenDialogForNewField(false)}
          fullWidth
          sx={{ "& .MuiDialog-paper": { maxWidth: "520px" } }}
        >
          <DialogTitle sx={{ m: 0, p: 2 }}>
            <Typography variant="h6">Add More Fields</Typography>
            <IconButton
              aria-label="close"
              onClick={() => setOpenDialogForNewField(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseRoundedIcon />
            </IconButton>
          </DialogTitle>
          <Typography
            gutterBottom
            sx={{ padding: "0 16px", marginBottom: "15px" }}
          >
            Add custom fields to enhance more details.
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              padding: "0 16px",
            }}
          >
            {Object.keys(cardDetails?.additionalFields ?? {}).map((key) => (
              <>
                <Grid item style={{ width: "85%" }}>
                  <TextField
                    placeholder="Name"
                    variant="standard"
                    fullWidth
                    value={key}
                    disabled
                    sx={{ mb: 2 }}
                  />
                </Grid>
                <div
                  className="d-flex align-items-center"
                  style={{ width: "100%" }}
                >
                  <Grid item style={{ width: "85%" }}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      value={cardDetails.additionalFields[key]}
                      disabled
                      sx={{ mb: 2 }}
                    />
                  </Grid>
                  <IconButton
                    onClick={() => handleRemoveField(key)}
                    sx={{ marginLeft: 1 }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </div>
              </>
            ))}
            <Grid item style={{ width: "85%" }}>
              {/* <TextField
                placeholder='Name'
                variant="standard"
                fullWidth
                value={newFieldName}
                onChange={(e) => setNewFieldName(e.target.value)}
                sx={{ mb: 2 }}
              /> */}

              <TextField
                placeholder="Name"
                variant="standard"
                fullWidth
                value={newFieldName}
                onChange={(e) => setNewFieldName(e.target.value)}
                error={isOnlyNumbers.test(newFieldName)}
                helperText={
                  isOnlyNumbers.test(newFieldName)
                    ? "Input must not be numbers only"
                    : ""
                }
                sx={{ mb: 2 }}
              />
            </Grid>
            <div
              className="d-flex align-items-center"
              style={{ width: "100%" }}
            >
              <Grid item style={{ width: "85%" }}>
                <TextField
                  label="Input"
                  variant="outlined"
                  fullWidth
                  value={newFieldValue}
                  onChange={(e) => setNewFieldValue(e.target.value)}
                  sx={{ mb: 2 }}
                />
              </Grid>
              <IconButton onClick={handleAddField} sx={{ marginLeft: 1 }}>
                <FaPlusCircle className="icon-color" />
              </IconButton>
            </div>
          </Box>
          {/* <DialogActions>
            <Button onClick={() => setOpenDialogForNewField(false)} sx={{ backgroundColor: "#0044C6" }} variant="contained">
              Save
            </Button>
          </DialogActions> */}
        </Dialog>

        <div
          className="save-bottom"
          style={{
            textAlign: "right",
            backgroundColor: "#0044C614",
            padding: "12px",
            borderRadius: "0 0 8px 8px",
          }}
        >
          <Button
            variant="contained"
            sx={{ backgroundColor: "#0044C6" }}
            onClick={handleSave}
            disabled={!SaveEnable}
          >
            Save
          </Button>
        </div>
        {/* <ToastContainer toastClassName="email-toast-success" /> */}
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          message={
            <div>
              <strong>{snackbarMessage.title}</strong>
              <div>{snackbarMessage.body}</div>
            </div>
          }
          action={
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleCloseSnackbar}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          }
          anchorOrigin={{
            vertical: "top", // Position at the top
            horizontal: "right", // Position at the right
          }}
        />
      </div>
    </div>
  );
};

export default ProfileDetails;
